export var imageStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        variables = _ref.variables;
    return Object.assign({
      boxSizing: 'border-box',
      display: 'inline-block',
      verticalAlign: 'middle',
      width: props.fluid && '100%' || variables.width,
      height: variables.height || 'auto'
    }, props.circular && {
      borderRadius: variables.circularRadius
    }, props.avatar && {
      width: props.fluid && '100%' || variables.avatarSize,
      borderRadius: variables.avatarRadius
    });
  }
};
//# sourceMappingURL=imageStyles.js.map
